import React, { useState, useMemo, useEffect, useContext } from 'react';
import moment from 'moment';
import _ from 'lodash';
// MUI
import { DashboardProvider } from '../Dashboard/useDashboard';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import TabPanel from '../../components/TabPanel';
// API
import { getFootprintReport, getFootprintReportExport } from '../../api/footprintReport';
// COMPONENTS
import Filter from './components/Filter';
import Table from './components/Table';
import EngagementFileModal from './components/EngagementFileModal';
// CONTEXT
import useFootprintContext from './context/useFootprintContext';
import AppConst from '../../components/AppLayout/const';
import { toast } from 'react-toastify';

export default function FootprintReportDashboard() {
  const defaultFilter = {
    type: { label: 'ALL', value: null },
    date_from: moment().startOf('month').format('YYYY-MM-DD'),
    date_to: moment().endOf('month').format('YYYY-MM-DD'),
  };

  const { onSetTitle } = useContext(AppConst.AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [clearFilter, setClearFilter] = useState(0);
  const [footprints, setFootprint] = useState({
    loading: false,
    table: [],
  });
  const [engagementData, setEngagementData] = useState({
    toggle: false,
    data: [],
  });

  onSetTitle('Footprint Report Dashboard');

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateFilter = async () => {
    setFootprint({
      ...footprints,
      loading: true,
    });

    const request = {
      type: filterForm?.type?.value,
      date_from: filterForm?.date_from,
      date_to: filterForm?.date_to,
    };

    const response = await getFootprintReport(request);
    const { code, data } = response.data;

    if (code === '200') {
      setFootprint({
        ...footprints,
        loading: false,
        table: data,
      });
    }
  };

  const handleClearFilter = async () => {
    setFilterForm(defaultFilter);
    setClearFilter(_.random(10, true));
  };

  const handleViewEngagement = (row) => {
    setEngagementData({
      ...engagementData,
      toggle: true,
      data: row,
    });
  };

  const handleExportFootprintReport = async () => {
    try {
      toast.loading('Processing request please wait...');
      const request = {
        type: filterForm?.type?.value,
        date_from: filterForm?.date_from,
        date_to: filterForm?.date_to,
      };

      const response = await getFootprintReportExport(request);
      const { code, result } = response.data.response;

      if (code === '200') {
        window.location.href = result;
        toast.success(`File has been successfully exported: ${response?.data?.file_name}`);
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleGenerateFilter();
  }, [clearFilter]);

  return (
    <DashboardProvider>
      <useFootprintContext.Provider
        value={useMemo(
          () => ({
            // GET
            activeTab,
            filterForm,
            clearFilter,
            footprints,
            engagementData,
            // SET
            setFilterForm,
            setClearFilter,
            setFootprint,
            setEngagementData,
            // METHOD
            handleGenerateFilter,
            handleClearFilter,
            handleChangeActiveTab,
            handleViewEngagement,
            handleExportFootprintReport,
          }),
          [filterForm, footprints, engagementData],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab
                      label='Footprint'
                      id='footprint-tab'
                      aria-controls='footprint-tab'
                      name='footprint-tab'
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={0}>
                  <Table />
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {engagementData?.toggle ? <EngagementFileModal /> : ''}
      </useFootprintContext.Provider>
    </DashboardProvider>
  );
}
